import Vue from "vue";
import resize from "@/directives/v-resize";

Vue.directive("resize", resize);
